export const HTTP_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
};
